import { Checkbox } from "@primer/react";

export const helpTableConfig = () => {
    return [
        {
            id: "select",
            field: "",
            sortBy: "basic",
            header: () => <Checkbox value="default" disabled />,
            rowHeader: true,
            maxWidth: 40
        },
        {
            id: "question",
            header: "Вопрос",
            field: "question",
        },
        {
            id: "answer",
            header: "Ответ",
            field: "answer",
        },
        {
            id: "langs",
            header: "Языки",
            field: "langs",
        },
        {
            id: "actions",
            header: "",
            field: "actions",
        },
    ];
}
